import { createContext } from 'react';

export const EventReportingManagerContext = createContext({
    context: {},
    enabled: true,
});
